import React, { useEffect } from "react";
import { Box, Button, Fade, Modal, Stack } from "@mui/material";
import TablaProductos from "./TablaProductos";

export const ModalInfo = ({
  isOpenModalInfo,
  handleCloseModalInfo,
  datosCompra,
}) => {

  return (
    <Modal
      open={isOpenModalInfo}
      onClose={handleCloseModalInfo}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={isOpenModalInfo} timeout={400}>

      <Box sx={styleCorreoModal}>
        <h3>Datos de tu compra</h3>
        <TablaProductos datosCompra={datosCompra} />
        <Stack direction="row" justifyContent="end" alignItems="end" mt={2}>
          <Button onClick={handleCloseModalInfo} variant="contained">Cerrar</Button>
        </Stack>
      </Box>
      </Fade>
    </Modal>
  );
};

const styleCorreoModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  maxWidth: "70vw",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};
